"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const component_json_1 = require("./component-json");
exports.ComponentDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Component', component_json_1.ComponentJsonMapper);
